import { render, staticRenderFns } from "./LiveSportPage.vue?vue&type=template&id=0e2532ed&scoped=true&"
import script from "./LiveSportPage.vue?vue&type=script&lang=js&"
export * from "./LiveSportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2532ed",
  null
  
)

export default component.exports